export const smartRecoFeatureKey = 'smartReco';
